import { ApiEntity } from "app/api/models/api-entity.model";

export class UserRowModel extends ApiEntity{
  constructor(public id: number = null,public firstNames: string= "",public lastName: string= "",public fullName: string= "", public username: string= "", public roles: string= "", public isActive: boolean= false, ){      
	super();	
  }
}
